import { Link } from "react-router-dom";

export type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-xs md:text-sm text-foreground-500">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}